import React, { useState, useEffect } from "react";
import TransactionTypeBadge from "../../../pages/MainScreens/Transactions/TransactionTypeBadge/TransactionTypeBadge";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "./OrderDetails.module.scss";
import { useDispatch } from "react-redux";
import { getTransactionDetailsAction } from "../../../../features/user/userSlice";
import { format } from "date-fns";
import { formatPrice } from "../../../../utils/utils";
import { calcLength } from "framer-motion";
import Tooltip from "../../Tooltip/Tooltip";
import CopyBtn from "../../CopyBtn/CopyBtn";

const OrderDetails = ({ show, handleClose, orderId }) => {
  const dispatch = useDispatch();

  const [transactionDetails, setTransactionDetails] = useState({});
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(true);

  const getDetails = async () => {
    setLoading(true);
    try {
      const dataObj = {
        transactionId: orderId.transactionId,
        orderId: orderId.orderId,
      };
      const response = await dispatch(getTransactionDetailsAction(dataObj));
      if (response.status === 200) {
        
        setTransactionDetails(response.data.data[0]);
        setImageURL(response.data.data.imageUrl);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      getDetails();
    }
  }, [show]);

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      className={styles.order_details}
      title="Order Details"
    >
      <ul>
        <li>
          <h6>Order Id:</h6>
          <h6>
            <Tooltip
              icon={<span>{orderId?.orderId}</span>}
              content={
                <>
                  <CopyBtn text={orderId?.orderId} /> {orderId?.orderId}
                </>
              }
            />
          </h6>
        </li>
        <li>
          <h6>Quantity:</h6>
          <h6>{formatPrice(Number(transactionDetails?.quantity))}</h6>
        </li>
        <li>
          <h6>Price:</h6>
          <h6>${formatPrice(Number(transactionDetails?.price))}</h6>
        </li>
      </ul>
      <ul>
        <li>
          <h6>Payment method:</h6>
          <h6>
            {/* {transactionDetails?.order_redemption_tracking?.payment_method} */}
            FIAT
          </h6>
        </li>
        <li>
          <h6>Date:</h6>
          <h6>
            {transactionDetails?.created_at &&
              format(new Date(transactionDetails?.created_at), "dd MMM, yyyy")}
          </h6>
        </li>
        <li>
          <h6>Shipping address:</h6>
          <h6>
            {transactionDetails?.order_redemption_tracking?.shipping_address}
          </h6>
        </li>
      </ul>
      <ul>
        <li>
          <h6>Status:</h6>
          <TransactionTypeBadge type={"primary"}>
            {transactionDetails?.status?.toLowerCase()}
          </TransactionTypeBadge>
        </li>
        <li>
          <h6>Tracking ID:</h6>
          <h6>
            <Tooltip
              icon={<span>{transactionDetails?.order_redemption_tracking?.tracking_id}</span>}
              content={
                <>
                  <CopyBtn text={transactionDetails?.order_redemption_tracking?.tracking_id} />{" "}
                  {transactionDetails?.order_redemption_tracking?.tracking_id}
                </>
              }
            />
          </h6>
        </li>
        {/* <li>
          <h6>Courier Partner: </h6>
          <h6>Shipstation</h6>
        </li> */}
      </ul>
      {/* <Button className={styles.continue_btn} onClick={handleClose} fluid>
        Continue
      </Button> */}
    </Modal>
  );
};

export default OrderDetails;
